<template>
    <div>  
      <div class="modal fade" id="logModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div
            class="modal-content color-scheme-light"
            style="width: 100%; max-width: 100%"
          >
            <div class="modal-header faded smaller">
              <h5 class="text-success modal-title" id="logModalLabel">Historial de Logs</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive tableFixHead" style="width: 100%;">
                <table class="table table-striped table-bordered table-hover">
                  <thead class="bg-light">
                    <tr>
                      <th>Datos</th>
                      <th>Mensaje</th>
                      <th>Tipo</th>
                      <th>Modelo</th>
                      <th>Usuario</th>
                      <th>Fecha Creación</th>
                      <th>Operación</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody
                    :class="{
                      'loader-wrapper': !logsCargados,
                    }"
                  >
                    <LoaderComponent
                      :condicion="logsCargados"
                    ></LoaderComponent>  
                    <tr v-for="log in logs" :key="log.id">
                      <td>
                        <pre>{{ log.data }}</pre>
                      </td>
                      <td>{{ log.mensaje }}</td>
                      <td>
                        <span :class="{'badge bg-danger': log.tipo === 'ERROR', 'badge bg-info': log.tipo === 'INFO'}">{{ log.tipo }}</span>
                      </td>
                      <td>{{ log.modelo }}</td>
                      <td>{{ log.username }}</td>
                      <td>{{ formatDate(log.fecha_creacion) }}</td>
                      <td>{{ log.operacion }}</td>
                      <td>{{ log.accion }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                    <i class="fas fa-door-open"></i> Cerrar
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import DynamicService from "@/services/commons/DynamicService"
  import LoaderComponent from "@/components/commons/LoaderComponent.vue";

  export default {

    components: {
      LoaderComponent
    },
    props:{
      modulo:{
        type: String,
        default: '',
      },
      path:{
        type: String,
        default: '',
      },
      params:{
        type: Object,
        default: () => ({})
      }
    },
    data(){
      return {
        logs: [],
        logsCargados: false,
      }
    },
    mounted(){
      this.refreshLogs();
    },
    methods: {
      refreshLogs(){
        let self = this;
        self.logsCargados = false;
        self.logs = [];
        self.params.quitar_paginacion = true;
        DynamicService.fetch(
          self.modulo,
          self.path,
          self.params
        )
        .then(response => {
          self.logs = response.data;
          self.logsCargados = true;
        })

      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      },
    },
  };
  </script>
  
  <style scoped>
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  </style>